import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
// import { NavigationActions } from 'react-navigation'
import * as StoreState from 'x/modules/store/StoreState'
// import * as i18nState from '../i18n/i18nState'

import SellerStoresView from './SellerStoresView'
import {
  getMyProfile,
  getSellerStores,
  getSellerStoresShouldFetch,
  getSellerStoresIsFetching,
  getMyPendingStores,
  getSelectedStore,
} from 'x/redux/selectors'

// https://github.com/react-community/react-navigation/issues/51
// const mapStateToProps = ({ nav }) => {
//   const currentRouteIndex = nav.routes[nav.index].index;
//   const currentRoute = nav.routes[nav.index].routes[currentRouteIndex];
//
//   return { currentRoute }
// }

export default connect(
  (state) => ({
    stores: getSellerStores(state),
    myPendingStores: getMyPendingStores(state),
    shouldFetch: getSellerStoresShouldFetch(state),
    isFetching: getSellerStoresIsFetching(state),
    profile: getMyProfile(state),
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => {
    return {
      // navigate: bindActionCreators(NavigationActions.navigate, dispatch),
      dispatch,
      // i18nStateActions: bindActionCreators(i18nState, dispatch),
      fetchStores: bindActionCreators(StoreState.fetchSellerStores, dispatch),
      applyInviteCode: bindActionCreators(StoreState.applyInviteCode, dispatch),
      appendPendingStore: bindActionCreators(StoreState.appendPendingStore, dispatch),
    }
  }
)(SellerStoresView)
